import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
      <h3 className="tagline">
          Not Found!!!
      </h3>
    )
  }
}
